import BottomNav from './BottomNav'
import { NavLocation } from './types';

export { NavLocation };
export default BottomNav;
